import { BaseNode } from './BaseNode';
import { useFlowName } from './useFlowName';

export function SubFlowNode({ data }: { data: { label: string; flowId?: string; alias?: string } }) {
  const target = useFlowName(data.flowId);

  return (
    <BaseNode
      type="subflow"
      label={data.label}
      alias={data.alias}
      lines={[{ text: target ?? (data.flowId ? 'Triggers a flow once' : 'No target flow selected') }]}
    />
  );
}
